"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleableWidgetToolbarButtons = void 0;
var react_1 = __importStar(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var inversify_react_1 = require("inversify-react");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var widgetStyle_1 = require("Utils/widgetStyle");
var StringManipulater_1 = require("@CommonFrontend/Utils/StringManipulater");
var FilterableColorProvider_1 = require("../Styling/FilterableColorProvider");
var StyleableBehaviours_1 = require("../Behaviours/Styleable/StyleableBehaviours");
var UseOnStyleChangeHandler_1 = require("./UseOnStyleChangeHandler");
var ScrollLock_1 = __importDefault(require("Project/Utils/ScrollLock"));
var PropertyControls_1 = require("./PropertyControls/PropertyControls");
var LightDarkThemeProvider_1 = require("Utils/LightDarkThemeProvider");
var styles = __importStar(require("./Styleable.css"));
exports.StyleableWidgetToolbarButtons = (0, mobx_react_1.observer)(function (_a) {
    var _b, _c;
    var element = _a.element, anchorElement = _a.anchorElement;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var _d = __read((0, react_1.useState)(undefined), 2), cachedHasAnyOverrides = _d[0], setCachedHasAnyOverrides = _d[1];
    var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type);
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "styleable" });
    (0, tiny_invariant_1.default)(!!styleableConfig, "Cannot render StyleableWidgetToolbarButtons for a widget that doesn't have the styleable trait");
    var blockStyle = blockStore.blockStyleStore.model[styleableConfig.styleKey] || {};
    var overrides = "style" in element ? element.style : {};
    var style = (0, widgetStyle_1.widgetStyle)({
        blockStyle: blockStyle,
        colorProvider: colorProvider,
        overrides: overrides,
        styleableConfig: styleableConfig,
        paragraphBlockStyle: blockStore.blockStyleStore.getElementStyle("p"),
        heading2BlockStyle: blockStore.blockStyleStore.getElementStyle("h2"),
    });
    var centralisedChangeHandler = (0, UseOnStyleChangeHandler_1.useOnStyleChangeHandler)({
        elements: [element],
        widgetManager: widgetManager,
    });
    var onChangeHandler = function (property, val) {
        var onChange = function () { return centralisedChangeHandler(property, val); };
        onChange();
    };
    var widgetHasAnyOverrides = !(0, lodash_1.isEmpty)(overrides);
    var widgetHasAnyOverridesWithCache = cachedHasAnyOverrides !== null && cachedHasAnyOverrides !== void 0 ? cachedHasAnyOverrides : widgetHasAnyOverrides;
    var onSliderMouseDown = function () {
        setCachedHasAnyOverrides(!!widgetHasAnyOverrides);
        var handleMouseUp = function () {
            setCachedHasAnyOverrides(undefined);
            document.removeEventListener("mouseup", handleMouseUp);
        };
        document.addEventListener("mouseup", handleMouseUp);
    };
    var showStyleableControls = styleableConfig &&
        !((config === null || config === void 0 ? void 0 : config.nodeType) === "textElement") &&
        hasStyleAccess(styleableConfig.styleAccessKey, stylePermissionStore) &&
        !((_b = styleableConfig.hideInToolbarInBlocks) === null || _b === void 0 ? void 0 : _b.includes(blockStore.blockType));
    var propertiesGroupedByTab = (0, lodash_1.groupBy)(styleableConfig.properties, function (p) { var _a; return (_a = p.groupKey) !== null && _a !== void 0 ? _a : "no group"; });
    var nonGroupedProperties = (_c = propertiesGroupedByTab["no group"]) !== null && _c !== void 0 ? _c : [];
    delete propertiesGroupedByTab["no group"];
    var tabGroups = Array.from(Object.entries(propertiesGroupedByTab));
    var commonPropertyControlProps = {
        onChangeHandler: onChangeHandler,
        target: element,
        style: style,
        onSliderMouseDown: onSliderMouseDown,
    };
    var controlsInTabList = tabGroups.length > 0;
    return (react_1.default.createElement(LightDarkThemeProvider_1.LightDarkThemeProvider, { theme: "dark" }, function (_a) {
        var _b;
        var lightDarkClassName = _a.lightDarkClassName;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            showStyleableControls ? (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Styles, null) })); }, autoStack: true },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: lightDarkClassName, gap: "m" },
                    !controlsInTabList && (react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, (_b = config === null || config === void 0 ? void 0 : config.displayName) !== null && _b !== void 0 ? _b : (0, StringManipulater_1.titleCase)(element.type),
                        " styles")),
                    controlsInTabList && (react_1.default.createElement(kaleidoscope_1.Tabs, null,
                        react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Style options", isBordered: true, align: kaleidoscope_1.TabListAlign.Start }, tabGroups.map(function (_a) {
                            var _b = __read(_a, 1), tabLabel = _b[0];
                            return (react_1.default.createElement(kaleidoscope_1.Tab, { className: styles.tab, key: tabLabel }, tabLabel));
                        })),
                        react_1.default.createElement(kaleidoscope_1.TabPanels, null, tabGroups.map(function (_a) {
                            var _b = __read(_a, 2), tabLabel = _b[0], tabProperties = _b[1];
                            return (react_1.default.createElement(kaleidoscope_1.TabPanel, { key: tabLabel },
                                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" }, tabProperties.map(function (property) { return (react_1.default.createElement(PropertyControls_1.PropertyControls, __assign({}, commonPropertyControlProps, { property: property, key: property.path }))); }))));
                        })))),
                    nonGroupedProperties.map(function (property) { return (react_1.default.createElement(PropertyControls_1.PropertyControls, __assign({}, commonPropertyControlProps, { property: property, key: property.path }))); })))) : null,
            widgetHasAnyOverridesWithCache && showStyleableControls && (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.StylesBrushUpdate, null), tooltip: { content: "Style modified" } }), theme: "dark", offset: 8, autoStack: true },
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: function () {
                        (0, ScrollLock_1.default)(anchorElement, function () {
                            var nextBlockStyle = (0, lodash_1.merge)({}, blockStyle, overrides);
                            blockStore.blockStyleStore.setElementStyle(styleableConfig.styleKey, nextBlockStyle);
                            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("styleable", {
                                action: StyleableBehaviours_1.StyleableAction.PropagateElementStyle,
                                type: element.type,
                            }));
                            serverTelemetry.sendOverridesTelemetry();
                        });
                    } }, "Update block"),
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Retry, null), disabled: !widgetHasAnyOverrides, onClick: function () {
                        (0, ScrollLock_1.default)(anchorElement, function () {
                            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("styleable", {
                                action: StyleableBehaviours_1.StyleableAction.ClearElementStyles,
                                path: widgetManager.getPath(element),
                            }));
                        });
                    } }, "Reset style")))));
    }));
});
var hasStyleAccess = function (styleAccessKey, stylePermissionStore) {
    if (!styleAccessKey) {
        return true;
    }
    return stylePermissionStore.allowStyle(styleAccessKey);
};
